import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useInvitationStore } from '@/lib/store/invitationStore';
import { Button, Card } from '@/components/common';
import { formatDistanceToNow } from 'date-fns';

export default function InvitationsWidget() {
  const { userInvitations, isLoading, fetchUserInvitations } = useInvitationStore();
  
  useEffect(() => {
    fetchUserInvitations();
  }, [fetchUserInvitations]);
  
  if (isLoading) {
    return (
      <Card className="p-6">
        <h2 className="text-lg font-semibold mb-4">Pending Invitations</h2>
        <div className="flex justify-center py-4">
          <div className="animate-spin h-6 w-6 border-t-2 border-b-2 border-primary rounded-full"></div>
        </div>
      </Card>
    );
  }
  
  if (userInvitations.length === 0) {
    return null; // Don't show the widget if there are no invitations
  }
  
  return (
    <Card className="p-6">
      <h2 className="text-lg font-semibold mb-4">Pending Invitations</h2>
      
      <div className="space-y-4">
        {userInvitations.map(invitation => (
          <div 
            key={invitation.id} 
            className="p-4 border rounded-lg"
          >
            <div className="font-medium">{invitation.team?.name}</div>
            <div className="text-sm text-gray-500 mb-3">
              <span className="capitalize">{invitation.role}</span> • 
              <span className="ml-1">
                Invited {formatDistanceToNow(new Date(invitation.created_at), { addSuffix: true })}
              </span>
            </div>
            
            <Link to={`/invitations/${invitation.token}`}>
              <Button variant="primary" size="sm" className="w-full">
                View Invitation
              </Button>
            </Link>
          </div>
        ))}
      </div>
    </Card>
  );
} 